(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener(
				'change',
				debounce((event) => {
					const body = JSON.stringify({ note: event.target.value });
					fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
				}, 300)
			);
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-comparison"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  // 获取所有产品对比分区
  const productComparisons = document.querySelectorAll('.product-comparison-section');
  
  productComparisons.forEach(section => {
    // 在每个分区内查找元素
    const tabs = section.querySelectorAll('.tab');
    const contents = section.querySelectorAll('.tab-content');
    
    // 确保第一个标签默认打开
    const firstTab = tabs[0];
    const firstContent = contents[0];
    if (firstTab && firstContent) {
      firstTab.classList.add('active');
      firstContent.style.display = 'block';
    }
    
    // 为每个标签添加点击事件
    tabs.forEach(tab => {
      tab.addEventListener('click', function() {
        const tabId = this.getAttribute('data-tab');
        
        // 只更新当前分区内的标签状态
        tabs.forEach(t => t.classList.remove('active'));
        this.classList.add('active');
        
        // 只更新当前分区内的内容显示
        contents.forEach(content => {
          content.style.display = 'none';
        });
        
        // 显示当前标签对应的内容
        const contentElement = section.querySelector(`#${tabId}-content`);
        if (contentElement) {
          contentElement.style.display = 'block';
        }
      });
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-tabs-showcase"] && !window.DesignMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  try {
    // 获取所有产品标签展示分区
    const productShowcases = document.querySelectorAll('.product-tabs-showcase-section');
    
    productShowcases.forEach(showcase => {
      // 在每个分区内查找元素
      const tabs = showcase.querySelectorAll('.tab');
      const contents = showcase.querySelectorAll('.tab-content');
      const images = showcase.querySelectorAll('.tab-image-container');
      const mobileSelect = showcase.querySelector('.mobile-tabs-select');
      const swiperContainer = showcase.querySelector('.product-tabs-swiper-container');
      
      // console.log('找到标签数量:', tabs.length);
      
      let productTabsSwiper = null;
      
      // 只在移动端初始化Swiper
      if (window.innerWidth <= 768 && swiperContainer) {
        // 动态加载Swiper
        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@8/swiper-bundle.min.js';
        script.onload = function() {
          try {
            productTabsSwiper = new Swiper(swiperContainer, {
              slidesPerView: 1,
              spaceBetween: 30,
              loop: false,
              pagination: {
                el: showcase.querySelector('.product-tabs-swiper-pagination'),
                clickable: true
              },
              on: {
                slideChange: function() {
                  const slides = showcase.querySelectorAll('.product-tabs-swiper-slide');
                  if (slides[productTabsSwiper.activeIndex]) {
                    const tabId = slides[productTabsSwiper.activeIndex].getAttribute('data-tab');
                    switchTab(tabId, showcase);
                  }
                }
              }
            });
          } catch (error) {
            console.error('初始化Swiper出错:', error);
          }
        };
        document.head.appendChild(script);
      }
      
      /**
       * 切换标签页
       * @param {string} tabId - 标签ID
       * @param {HTMLElement} showcase - 当前分区元素
       */
      function switchTab(tabId, showcase) {
       // console.log('切换到标签:', tabId);
        
        // 更新标签状态
        const tabs = showcase.querySelectorAll('.tab');
        tabs.forEach(t => t.classList.remove('active'));
        const activeTab = showcase.querySelector(`.tab[data-tab="${tabId}"]`);
        if (activeTab) activeTab.classList.add('active');
        
        // 更新内容显示
        const contents = showcase.querySelectorAll('.tab-content');
        contents.forEach(content => {
          content.classList.remove('active');
        });
        
        // 更新图片显示
        const images = showcase.querySelectorAll('.tab-image-container');
        images.forEach(image => {
          image.classList.remove('active');
        });
        
        const contentElement = showcase.querySelector(`#${tabId}-content`);
        if (contentElement) {
          contentElement.classList.add('active');
        }
        
        const imageElement = showcase.querySelector(`#${tabId}-image`);
        if (imageElement) {
          imageElement.classList.add('active');
        }
        
        // 同步移动端选择框
        const mobileSelect = showcase.querySelector('.mobile-tabs-select');
        if (mobileSelect) {
          mobileSelect.value = tabId;
        }
        
        // 同步移动端滑块内容
        const mobileSlides = showcase.querySelectorAll('.product-tabs-swiper-slide');
        mobileSlides.forEach(slide => {
          slide.classList.remove('active');
        });
        
        const activeMobileSlide = showcase.querySelector(`.product-tabs-swiper-slide[data-tab="${tabId}"]`);
        if (activeMobileSlide) {
          activeMobileSlide.classList.add('active');
        }
        
        // 如果有Swiper实例，同步滑块位置
        if (productTabsSwiper) {
          const slides = Array.from(showcase.querySelectorAll('.product-tabs-swiper-slide'));
          const slideIndex = slides.findIndex(slide => slide.getAttribute('data-tab') === tabId);
          if (slideIndex !== -1) {
            productTabsSwiper.slideTo(slideIndex);
          }
        }
      }
      
      // 桌面端标签切换
      tabs.forEach(tab => {
        tab.style.pointerEvents = 'auto';
        tab.style.cursor = 'pointer';
        tab.style.position = 'relative';
        tab.style.zIndex = '5';
        
        tab.addEventListener('click', function(e) {
        //  console.log('标签被点击:', this.textContent.trim());
          const tabId = this.getAttribute('data-tab');
         // console.log('点击的标签ID:', tabId);
          switchTab(tabId, showcase);
          e.stopPropagation(); // 阻止事件冒泡
        });
      });
      
      // 移动端下拉菜单切换
      if (mobileSelect) {
        mobileSelect.addEventListener('change', function() {
          const tabId = this.value;
          switchTab(tabId, showcase);
          
          // 同步滑块位置
          if (productTabsSwiper) {
            const slides = Array.from(showcase.querySelectorAll('.product-tabs-swiper-slide'));
            const slideIndex = slides.findIndex(slide => slide.getAttribute('data-tab') === tabId);
            if (slideIndex !== -1) {
              productTabsSwiper.slideTo(slideIndex);
            }
          }
        });
      }
    });
  } catch (error) {
    console.error('标签脚本总体错误:', error);
  }
});

  } catch(e) { console.error(e); }
})();
})();
